import { Market } from 'clickNgo/configs/geo'
import { Region } from 'clickNgo/configs/geo'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

export enum ContactFlagRequestAction {
  Add = 'Add',
  Delete = 'Delete',
}

export enum ContactFlagRequestStatus {
  New = 'New',
  Done = 'Done',
  WIP = 'WIP',
  Rejected = 'Rejected',
}

export interface IContactFlag {
  code: string
  contactId: string
  entryId: number
  type: ProfilingCodeType.Campaigns | ProfilingCodeType.Tools | ProfilingCodeType.UserRights
  action?: ContactFlagRequestAction
  ageDays?: number
  caption?: string
  comment?: string
  country?: string
  created?: Date
  createdBy?: string
  market?: Market
  modified?: Date
  modifiedBy?: string
  notificationSendLog?: string
  partnerId?: string
  processedDate?: Date
  refEntryId?: number
  region?: Region
  requestStarted?: Date
  source?: string
  status?: ContactFlagRequestStatus
  topPartnerId?: string
}

export interface IContactFlags {
  [ProfilingCodeType.UserRights]: IContactFlag[]
  [ProfilingCodeType.Campaigns]: IContactFlag[]
  [ProfilingCodeType.Tools]: IContactFlag[]
}

export interface IToolAccessConditions {
  uniqueId: string
  flag: string
  partnerId: string
  conditionFulfilled: number
  comment: string
}

export interface IToolsCodeRules {
  toolsFlagCode: string
  flagCode: string
  market?: string
  type: 'UserRights' | 'EPI'
}
